module.exports = __webpack_public_path__ + "static/media/MainHome.d20b6f8a.svg";